import classNames from 'classnames/bind';
import styles from './Following.module.scss';
import images from '~/assets/images';

const cx = classNames.bind(styles)

function Following() {
    return (
        <div className={cx('error-page')}>
            <img src={images.error} aria-hidden alt="Error Image" className={cx('error-image')} />
            <h1> 关注功能开发中 🥹</h1>
            <p>敬请期待</p>
        </div>
    );
}

export default Following;